<template>
  <div class="kye-report-fzkp006">
    <div class="fzkp006_container">
      <div class="fzkp006-main-cell"
        @click="cardClick(index)"
        :class="{
          'fzkp006_highlight': value === index,
          [`fzkp006-main-cell-${index}`]: true
        }"
        v-for="(card, index) in data" :key="index">
        <div class="fzkp006-main-cell-warp">
          <div class="fzkp006-main-cell-top">
            <img
              class="fzkp006-main-cell-top_icon"
              @click="handleClick('mainIcon1', index)"
              :src="card.mainIcon || mainIcon"
              v-events="{ eventsMap, ignoreEventName, args: ['mainIcon1', index, card.mainIcon]}"
            />
            <div
              class="fzkp006-main-cell-top_text"
              @click="handleClick('mainTitle', index)"
              v-events="{ eventsMap, ignoreEventName, args: ['mainTitle', index, card.mainTitle]}"
            >{{ card.mainTitle }}</div>
            <KyeReportCardQuestion
              class="main-icon"
              :icon="card.mainIcon"
              :popover="card.popover"
              @click="handleClick('mainIcon2', index)">
              <slot :name="'tooltip'+index"></slot>
            </KyeReportCardQuestion>
          </div>
          <div class="fzkp006-main-cell-index" @click="handleClick('mainIndex', index)">
            <div
              class="fzkp006-main-cell-index_left"
              v-events="{ eventsMap, args: ['mainTitle', index, card.mainIndex]}"
            >{{ card.mainIndex }}</div>
            <div
              class="fzkp006-main-cell-index_right"
              @click="handleClick('mainIndexUnit', index)"
              v-events="{ eventsMap, ignoreEventName, args: ['mainIndexUnit', index, card.mainIndexUnit]}"
            >
              {{ card.mainIndexUnit }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <card-popover
      :popoverConfig="popoverConfig"
    >
      <slot :name="cardPopoverSlotName"></slot>
    </card-popover>
  </div>
</template>

<script>
import KyeReportCardQuestion from '../common/question.vue'
import icon from '../../asset/images/fzkp006.png'
export default {
  name: 'KyeReportFzkp006',
  components: {
    KyeReportCardQuestion,
  },
  props: {
    data: {
      type: Array,
      default: () => ([])
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      mainIcon: icon
    }
  },
  methods: {
    handleClick(eventName, index) {
      if (Number(index) >= 0) {
        this.$emit(eventName, index, this.data)
      } else {
        this.$emit(eventName, this.data)
      }
    },
    cardClick(index) {
      this.$emit('cardClick', index, this.data)
      this.$emit('input', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.kye-report-fzkp006 {
  @import '../../style/extend.scss';
  width: 100%;
  height: 67px;
  border-radius: 4px;
  background: linear-gradient(181deg, #FFF6F1 9%, #FFFEFD 70%, #FFFFFF 90%);
  box-sizing: border-box;
  box-shadow: 0px 2px 6px 0px rgba(211, 211, 211, 0.5);
  border: 1px solid #FFFFFF;
  .fzkp006_container{
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    height: 100%;
    >div:last-child{
      border: none;
      &::before{
        display: none;
      }
    }
    > div:first-child {
      &::after{
        border-top-left-radius: 4px;
      }
    }
  }
  .fzkp006-main-cell{
    flex:1;
    height: 100%;
    padding: 0 8px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 12px 0;
    &::before{
      content:"";
      width: 1px;
      background-color: #EBEDF5;
      position: absolute;
      top: 12px;
      bottom: 12px;
      right: 0;
    }
    .fzkp006-main-cell-warp{
      height: 100%;
    }
    .fzkp006-main-cell-top{
      display: flex;
      align-items: center;
      .fzkp006-main-cell-top_icon{
        width: 16px;
        height: 16px;
      }
      .fzkp006-main-cell-top_text{
        margin-left: 4px;
        margin-right: 4px;
      }
    }
    .fzkp006-main-cell-index{
      display: flex;
      color: var(--g-color-primary);
      margin-top: 4px;
      .fzkp006-main-cell-index_left{
        font-size: 16px;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: 0px;
      }
      .fzkp006-main-cell-index_right{
        font-size: 12px;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        position: relative;
        top: 2px;
      }
    }
  }
  .fzkp006_highlight{
    background: linear-gradient(180deg, #F2F1FF 0%, #FFFFFF 100%);
    &::after{
      content: "";
      width: 100%;
      height: 2px;
      background-color: var(--g-color-primary);
      position: absolute;
      top: -1px;
      left: 0;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/card/fzkp006/index.vue